import React from 'react'
import "./Reels_Hero.css";
// import { Link } from "react-router-dom";
import ReelsHero from '../../../Img/reelsHero.png'

const Reels_Hero = () => {
  return (
    <section className="hero_cover">
      <div className="container">
        <div className="hero_cover_content">
          <div className="row">
            <div className="col-sm-6">
              <div className="hero_cover_left">
                <div className="hero_cover_im">
                  {/* Insert image if needed */}
                </div>
                <h1 className="hero_cover_hd">
                  <span>Create, Share, and Inspire with Short Videos</span>
                </h1>
                <h2>Unleash Your Creativity with Harsafe Reels</h2>

                <div className="hero_cover_desc">
                  <p>Explore a vibrant platform to create, watch, and share reels, connecting people through engaging and inspiring short video content.</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="hero_cover_right">
              <div className="hero_cover_img">
                <img src={ReelsHero} alt="" />
                  {/* Insert image if needed */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Reels_Hero